<template>
  <section :id="id">
    <div class="wrap">
      <div class="section-head">
        <div>
          <h2>{{ title }}</h2>
          <p class="lead">{{ lead }}</p>
        </div>
      </div>
      <div class="cards">
        <article
          v-for="(card, index) in cards"
          :key="index"
          class="card fade-in"
        >
          <div class="kicker">{{ card.kicker }}</div>
          <h3>{{ card.title }}</h3>
          <p>{{ card.description }}</p>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup>
const props = defineProps({
  id: {
    type: String,
    required: true
  },
  title: {
    type: String,
    required: true
  },
  lead: {
    type: String,
    required: true
  },
  cards: {
    type: Array,
    required: true,
    validator: (value) => {
      return value.every(card =>
        card.hasOwnProperty('kicker') &&
        card.hasOwnProperty('title') &&
        card.hasOwnProperty('description')
      );
    }
  }
});
</script>

<style scoped>
/* Card section styles are inherited from global styles.css */
/* Component-specific overrides can go here if needed */
</style>
